export const UPDATE_APP_LOADING_STATUS = 'UPDATE_APP_LOADING_STATUS'
export const CALL_TABLES = 'CALL_TABLES'